<template>
  <v-dialog v-model="dialog" eager scrollable persistent>
    <template v-slot:activator="{ on, attrs }" pl-3>
      <v-btn
        v-bind="attrs"
        icon
        :title="$t('entitySelect.createNew')"
        v-on="on"
      >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
    </template>

    <SupplierFormDialog
      @dialogClosed="handleDialogClosed"
      :visible="dialog"
      v-if="dialog"
      @selectedSupplier="sendSelectedSupplier"
    />
  </v-dialog>
</template>

<script>
import SupplierFormDialog from '@/views/suppliers/SupplierFormDialog';

export default {
  name: 'SupplierCreationDialog',

  components: {
    SupplierFormDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    sendSelectedSupplier(supplier) {
      this.$emit('selected', supplier);
    },

    handleDialogClosed() {
      this.dialog = false;
      this.$emit('dialogClosed');
    },
  },
};
</script>
